var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"four-oh-four-container"},[_c('h1',[_vm._v("404")]),_vm._v(" "),_c('p',[_vm._v("Page Not Found")]),_vm._v(" "),_c('nuxt-link',{staticClass:"button button--primary",attrs:{"to":"/"}},[_vm._v("Back Home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }